import { EMAIL_VERIFICATION_COPY } from '../consts';
import { normalizeEmailAddress } from '../utils';
import { postCurrentUser } from './email-verification.requests.utils';

export { EmailVerificationRequestError } from './email-verification.requests.utils';

export const sendEmailVerificationCodeReq = () =>
  postCurrentUser('/api/users/me/email-verification', 'send', EMAIL_VERIFICATION_COPY.sendFailed);

export const changeEmailReq = (email: string, currentPassword: string) =>
  postCurrentUser('/api/users/me/email', 'change', EMAIL_VERIFICATION_COPY.changeFailed, {
    email: normalizeEmailAddress(email),
    currentPassword,
  });

export const confirmEmailVerificationReq = (code: string) =>
  postCurrentUser(
    '/api/users/me/email-verification/confirm',
    'confirm',
    EMAIL_VERIFICATION_COPY.confirmFailed,
    { code },
  );
